module.exports = __webpack_public_path__ + "img/door-closed.ab135951.svg";